
/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-unused-vars */
// noinspection JSUnusedGlobalSymbols
import type { components } from './all';

// Generate the TypeScript functions

export function LinkActionDiscriminator<T>(
    model: components["schemas"]["AdvisorLinkAction"] | components["schemas"]["ArticleSectionLinkAction"] | components["schemas"]["ArticleTagLinkAction"] | components["schemas"]["BrandClubLinkAction"] | components["schemas"]["BrandLinkAction"] | components["schemas"]["CampaignOfferLinkAction"] | components["schemas"]["CmsMenuItemLinkAction"] | components["schemas"]["CmsPageLinkAction"] | components["schemas"]["ContentfulPageLinkAction"] | components["schemas"]["DiscountLinkAction"] | components["schemas"]["ExternalLinkAction"] | components["schemas"]["FrontpageLinkAction"] | components["schemas"]["PlainLinkAction"] | components["schemas"]["ProductGroupLinkAction"] | components["schemas"]["ProductLinkAction"] | components["schemas"]["SeriesLinkAction"] | components["schemas"]["StaticPageLinkAction"] | components["schemas"]["StoreLinkAction"] | components["schemas"]["UserDefinedListLinkAction"],
    funcAdvisorLinkAction: (m: components['schemas']['AdvisorLinkAction']) => T,
    funcArticleSectionLinkAction: (m: components['schemas']['ArticleSectionLinkAction']) => T,
    funcArticleTagLinkAction: (m: components['schemas']['ArticleTagLinkAction']) => T,
    funcBrandClubLinkAction: (m: components['schemas']['BrandClubLinkAction']) => T,
    funcBrandLinkAction: (m: components['schemas']['BrandLinkAction']) => T,
    funcCampaignOfferLinkAction: (m: components['schemas']['CampaignOfferLinkAction']) => T,
    funcCmsMenuItemLinkAction: (m: components['schemas']['CmsMenuItemLinkAction']) => T,
    funcCmsPageLinkAction: (m: components['schemas']['CmsPageLinkAction']) => T,
    funcContentfulPageLinkAction: (m: components['schemas']['ContentfulPageLinkAction']) => T,
    funcDiscountLinkAction: (m: components['schemas']['DiscountLinkAction']) => T,
    funcExternalLinkAction: (m: components['schemas']['ExternalLinkAction']) => T,
    funcFrontpageLinkAction: (m: components['schemas']['FrontpageLinkAction']) => T,
    funcPlainLinkAction: (m: components['schemas']['PlainLinkAction']) => T,
    funcProductGroupLinkAction: (m: components['schemas']['ProductGroupLinkAction']) => T,
    funcProductLinkAction: (m: components['schemas']['ProductLinkAction']) => T,
    funcSeriesLinkAction: (m: components['schemas']['SeriesLinkAction']) => T,
    funcStaticPageLinkAction: (m: components['schemas']['StaticPageLinkAction']) => T,
    funcStoreLinkAction: (m: components['schemas']['StoreLinkAction']) => T,
    funcUserDefinedListLinkAction: (m: components['schemas']['UserDefinedListLinkAction']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'AdvisorLinkAction': return funcAdvisorLinkAction(model);
        case 'ArticleSectionLinkAction': return funcArticleSectionLinkAction(model);
        case 'ArticleTagLinkAction': return funcArticleTagLinkAction(model);
        case 'BrandClubLinkAction': return funcBrandClubLinkAction(model);
        case 'BrandLinkAction': return funcBrandLinkAction(model);
        case 'CampaignOfferLinkAction': return funcCampaignOfferLinkAction(model);
        case 'CmsMenuItemLinkAction': return funcCmsMenuItemLinkAction(model);
        case 'CmsPageLinkAction': return funcCmsPageLinkAction(model);
        case 'ContentfulPageLinkAction': return funcContentfulPageLinkAction(model);
        case 'DiscountLinkAction': return funcDiscountLinkAction(model);
        case 'ExternalLinkAction': return funcExternalLinkAction(model);
        case 'FrontpageLinkAction': return funcFrontpageLinkAction(model);
        case 'PlainLinkAction': return funcPlainLinkAction(model);
        case 'ProductGroupLinkAction': return funcProductGroupLinkAction(model);
        case 'ProductLinkAction': return funcProductLinkAction(model);
        case 'SeriesLinkAction': return funcSeriesLinkAction(model);
        case 'StaticPageLinkAction': return funcStaticPageLinkAction(model);
        case 'StoreLinkAction': return funcStoreLinkAction(model);
        case 'UserDefinedListLinkAction': return funcUserDefinedListLinkAction(model);
        default:
            return defaultFunc();
    }
}

export function CardListItemBaseDiscriminator<T>(
    model: components["schemas"]["ActiveCardListItem"] | components["schemas"]["BonusGiftListItem"],
    funcActiveCardListItem: (m: components['schemas']['ActiveCardListItem']) => T,
    funcBonusGiftListItem: (m: components['schemas']['BonusGiftListItem']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ActiveCardListItem': return funcActiveCardListItem(model);
        case 'BonusGiftListItem': return funcBonusGiftListItem(model);
        default:
            return defaultFunc();
    }
}

export function ProgressBarModelBaseDiscriminator<T>(
    model: components["schemas"]["AmountBasedProgressBarModel"] | components["schemas"]["ItemBasedProgressBarModel"],
    funcAmountBasedProgressBarModel: (m: components['schemas']['AmountBasedProgressBarModel']) => T,
    funcItemBasedProgressBarModel: (m: components['schemas']['ItemBasedProgressBarModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'AmountBasedProgressBarModel': return funcAmountBasedProgressBarModel(model);
        case 'ItemBasedProgressBarModel': return funcItemBasedProgressBarModel(model);
        default:
            return defaultFunc();
    }
}

export function ActiveCardBaseDiscriminator<T>(
    model: components["schemas"]["AmountBasedActiveCard"] | components["schemas"]["ItemBasedActiveCard"],
    funcAmountBasedActiveCard: (m: components['schemas']['AmountBasedActiveCard']) => T,
    funcItemBasedActiveCard: (m: components['schemas']['ItemBasedActiveCard']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'AmountBasedActiveCard': return funcAmountBasedActiveCard(model);
        case 'ItemBasedActiveCard': return funcItemBasedActiveCard(model);
        default:
            return defaultFunc();
    }
}

export function BoxButtonDiscriminator<T>(
    model: components["schemas"]["BoxButton"] | components["schemas"]["BoxButtonWithCreditCardOption"],
    funcBoxButton: (m: components['schemas']['BoxButton']) => T,
    funcBoxButtonWithCreditCardOption: (m: components['schemas']['BoxButtonWithCreditCardOption']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'BoxButton': return funcBoxButton(model);
        case 'BoxButtonWithCreditCardOption': return funcBoxButtonWithCreditCardOption(model);
        default:
            return defaultFunc();
    }
}

export function BasketMessageDiscriminator<T>(
    model: components["schemas"]["BasketMessageClickAndCollectViewModel"] | components["schemas"]["BasketMessageDiscountViewModel"] | components["schemas"]["BasketMessageGwpViewModel"] | components["schemas"]["BasketMessageMatasPlusViewModel"] | components["schemas"]["BasketMessageSameDayDeliveryViewModel"] | components["schemas"]["BasketMessageSampleGroupViewModel"] | components["schemas"]["BasketMessageShippingViewModel"],
    funcBasketMessageClickAndCollectViewModel: (m: components['schemas']['BasketMessageClickAndCollectViewModel']) => T,
    funcBasketMessageDiscountViewModel: (m: components['schemas']['BasketMessageDiscountViewModel']) => T,
    funcBasketMessageGwpViewModel: (m: components['schemas']['BasketMessageGwpViewModel']) => T,
    funcBasketMessageMatasPlusViewModel: (m: components['schemas']['BasketMessageMatasPlusViewModel']) => T,
    funcBasketMessageSameDayDeliveryViewModel: (m: components['schemas']['BasketMessageSameDayDeliveryViewModel']) => T,
    funcBasketMessageSampleGroupViewModel: (m: components['schemas']['BasketMessageSampleGroupViewModel']) => T,
    funcBasketMessageShippingViewModel: (m: components['schemas']['BasketMessageShippingViewModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'BasketMessageClickAndCollectViewModel': return funcBasketMessageClickAndCollectViewModel(model);
        case 'BasketMessageDiscountViewModel': return funcBasketMessageDiscountViewModel(model);
        case 'BasketMessageGwpViewModel': return funcBasketMessageGwpViewModel(model);
        case 'BasketMessageMatasPlusViewModel': return funcBasketMessageMatasPlusViewModel(model);
        case 'BasketMessageSameDayDeliveryViewModel': return funcBasketMessageSameDayDeliveryViewModel(model);
        case 'BasketMessageSampleGroupViewModel': return funcBasketMessageSampleGroupViewModel(model);
        case 'BasketMessageShippingViewModel': return funcBasketMessageShippingViewModel(model);
        default:
            return defaultFunc();
    }
}

export function BasketInfoBoxDiscriminator<T>(
    model: components["schemas"]["CheckoutPaymentTypeList"] | components["schemas"]["GiftCardInfoBox"] | components["schemas"]["CheckoutStoreList"] | components["schemas"]["BasketInfoBox"],
    funcCheckoutPaymentTypeList: (m: components['schemas']['CheckoutPaymentTypeList']) => T,
    funcGiftCardInfoBox: (m: components['schemas']['GiftCardInfoBox']) => T,
    funcCheckoutStoreList: (m: components['schemas']['CheckoutStoreList']) => T,
    funcBasketInfoBox: (m: components['schemas']['BasketInfoBox']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'CheckoutPaymentTypeList': return funcCheckoutPaymentTypeList(model);
        case 'GiftCardInfoBox': return funcGiftCardInfoBox(model);
        case 'CheckoutStoreList': return funcCheckoutStoreList(model);
        case 'BasketInfoBox': return funcBasketInfoBox(model);
        default:
            return defaultFunc();
    }
}

export function CmsButtonModelDiscriminator<T>(
    model: components["schemas"]["AdformButtonModel"] | components["schemas"]["LinkButtonModel"] | components["schemas"]["SignupButtonModel"] | components["schemas"]["LoginButtonModel"] | components["schemas"]["NoButtonModel"] | components["schemas"]["CustomButtonModel"],
    funcAdformButtonModel: (m: components['schemas']['AdformButtonModel']) => T,
    funcLinkButtonModel: (m: components['schemas']['LinkButtonModel']) => T,
    funcSignupButtonModel: (m: components['schemas']['SignupButtonModel']) => T,
    funcLoginButtonModel: (m: components['schemas']['LoginButtonModel']) => T,
    funcNoButtonModel: (m: components['schemas']['NoButtonModel']) => T,
    funcCustomButtonModel: (m: components['schemas']['CustomButtonModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'AdformButtonModel': return funcAdformButtonModel(model);
        case 'LinkButtonModel': return funcLinkButtonModel(model);
        case 'SignupButtonModel': return funcSignupButtonModel(model);
        case 'LoginButtonModel': return funcLoginButtonModel(model);
        case 'NoButtonModel': return funcNoButtonModel(model);
        case 'CustomButtonModel': return funcCustomButtonModel(model);
        default:
            return defaultFunc();
    }
}

export function ContentfulCustomDataFieldDiscriminator<T>(
    model: components["schemas"]["ContentfulProductListItemDataField"] | components["schemas"]["ContentfulPageActionDataField"] | components["schemas"]["ContentfulBrandDetailedDataField"] | components["schemas"]["ContentfulLiveEventDataField"] | components["schemas"]["ContentfulArticleModelDataField"] | components["schemas"]["ContentfulArticleGroupModelDataField"] | components["schemas"]["ContentfulSectionMenuDataField"],
    funcContentfulProductListItemDataField: (m: components['schemas']['ContentfulProductListItemDataField']) => T,
    funcContentfulPageActionDataField: (m: components['schemas']['ContentfulPageActionDataField']) => T,
    funcContentfulBrandDetailedDataField: (m: components['schemas']['ContentfulBrandDetailedDataField']) => T,
    funcContentfulLiveEventDataField: (m: components['schemas']['ContentfulLiveEventDataField']) => T,
    funcContentfulArticleModelDataField: (m: components['schemas']['ContentfulArticleModelDataField']) => T,
    funcContentfulArticleGroupModelDataField: (m: components['schemas']['ContentfulArticleGroupModelDataField']) => T,
    funcContentfulSectionMenuDataField: (m: components['schemas']['ContentfulSectionMenuDataField']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ContentfulProductListItemDataField': return funcContentfulProductListItemDataField(model);
        case 'ContentfulPageActionDataField': return funcContentfulPageActionDataField(model);
        case 'ContentfulBrandDetailedDataField': return funcContentfulBrandDetailedDataField(model);
        case 'ContentfulLiveEventDataField': return funcContentfulLiveEventDataField(model);
        case 'ContentfulArticleModelDataField': return funcContentfulArticleModelDataField(model);
        case 'ContentfulArticleGroupModelDataField': return funcContentfulArticleGroupModelDataField(model);
        case 'ContentfulSectionMenuDataField': return funcContentfulSectionMenuDataField(model);
        default:
            return defaultFunc();
    }
}

export function PageActionDiscriminator<T>(
    model: components["schemas"]["CustomActionType"] | components["schemas"]["LinkActionType"],
    funcCustomActionType: (m: components['schemas']['CustomActionType']) => T,
    funcLinkActionType: (m: components['schemas']['LinkActionType']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'CustomActionType': return funcCustomActionType(model);
        case 'LinkActionType': return funcLinkActionType(model);
        default:
            return defaultFunc();
    }
}

export function CustomActionDiscriminator<T>(
    model: components["schemas"]["CertificationCustomAction"] | components["schemas"]["JavascriptHookCustomAction"] | components["schemas"]["LiveEventCustomAction"] | components["schemas"]["SurveyCustomAction"] | components["schemas"]["VimeoCustomAction"],
    funcCertificationCustomAction: (m: components['schemas']['CertificationCustomAction']) => T,
    funcJavascriptHookCustomAction: (m: components['schemas']['JavascriptHookCustomAction']) => T,
    funcLiveEventCustomAction: (m: components['schemas']['LiveEventCustomAction']) => T,
    funcSurveyCustomAction: (m: components['schemas']['SurveyCustomAction']) => T,
    funcVimeoCustomAction: (m: components['schemas']['VimeoCustomAction']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'CertificationCustomAction': return funcCertificationCustomAction(model);
        case 'JavascriptHookCustomAction': return funcJavascriptHookCustomAction(model);
        case 'LiveEventCustomAction': return funcLiveEventCustomAction(model);
        case 'SurveyCustomAction': return funcSurveyCustomAction(model);
        case 'VimeoCustomAction': return funcVimeoCustomAction(model);
        default:
            return defaultFunc();
    }
}

export function DataLayerTrackingEventDiscriminator<T>(
    model: components["schemas"]["CheckoutErrorImpressionEvent"] | components["schemas"]["DefaultDataLayerTrackingEvent"] | components["schemas"]["EnhancedEcommerceTrackingEvent"] | components["schemas"]["TriggerTrackingEvent"] | components["schemas"]["VwoCampaignAssignmentTrackingEvent"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommerceBasketSize"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommerceCheckoutStep"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommerceProductAddToCartClick"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommerceProductClick"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommerceProductDetail"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommerceProductImpression"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommerceProductRemoveFromCartClick"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommercePromotionClick"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommercePromotionImpression"] | components["schemas"]["EnhancedEcommerceTrackingEventOfEcommercePurchase"] | components["schemas"]["EnhancedEcommerceTrackingEventOfCmsObjectTracking"] | components["schemas"]["EnhancedEcommerceTrackingEventOfGaStandardProductAddToCartClick"],
    funcCheckoutErrorImpressionEvent: (m: components['schemas']['CheckoutErrorImpressionEvent']) => T,
    funcDefaultDataLayerTrackingEvent: (m: components['schemas']['DefaultDataLayerTrackingEvent']) => T,
    funcEnhancedEcommerceTrackingEvent: (m: components['schemas']['EnhancedEcommerceTrackingEvent']) => T,
    funcTriggerTrackingEvent: (m: components['schemas']['TriggerTrackingEvent']) => T,
    funcVwoCampaignAssignmentTrackingEvent: (m: components['schemas']['VwoCampaignAssignmentTrackingEvent']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommerceBasketSize: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommerceBasketSize']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommerceCheckoutStep: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommerceCheckoutStep']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommerceProductAddToCartClick: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommerceProductAddToCartClick']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommerceProductClick: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommerceProductClick']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommerceProductDetail: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommerceProductDetail']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommerceProductImpression: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommerceProductImpression']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommerceProductRemoveFromCartClick: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommerceProductRemoveFromCartClick']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommercePromotionClick: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommercePromotionClick']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommercePromotionImpression: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommercePromotionImpression']) => T,
    funcEnhancedEcommerceTrackingEventOfEcommercePurchase: (m: components['schemas']['EnhancedEcommerceTrackingEventOfEcommercePurchase']) => T,
    funcEnhancedEcommerceTrackingEventOfCmsObjectTracking: (m: components['schemas']['EnhancedEcommerceTrackingEventOfCmsObjectTracking']) => T,
    funcEnhancedEcommerceTrackingEventOfGaStandardProductAddToCartClick: (m: components['schemas']['EnhancedEcommerceTrackingEventOfGaStandardProductAddToCartClick']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'CheckoutErrorImpressionEvent': return funcCheckoutErrorImpressionEvent(model);
        case 'DefaultDataLayerTrackingEvent': return funcDefaultDataLayerTrackingEvent(model);
        case 'EnhancedEcommerceTrackingEvent': return funcEnhancedEcommerceTrackingEvent(model);
        case 'TriggerTrackingEvent': return funcTriggerTrackingEvent(model);
        case 'VwoCampaignAssignmentTrackingEvent': return funcVwoCampaignAssignmentTrackingEvent(model);
        case 'EnhancedEcommerceTrackingEventOfEcommerceBasketSize': return funcEnhancedEcommerceTrackingEventOfEcommerceBasketSize(model);
        case 'EnhancedEcommerceTrackingEventOfEcommerceCheckoutStep': return funcEnhancedEcommerceTrackingEventOfEcommerceCheckoutStep(model);
        case 'EnhancedEcommerceTrackingEventOfEcommerceProductAddToCartClick': return funcEnhancedEcommerceTrackingEventOfEcommerceProductAddToCartClick(model);
        case 'EnhancedEcommerceTrackingEventOfEcommerceProductClick': return funcEnhancedEcommerceTrackingEventOfEcommerceProductClick(model);
        case 'EnhancedEcommerceTrackingEventOfEcommerceProductDetail': return funcEnhancedEcommerceTrackingEventOfEcommerceProductDetail(model);
        case 'EnhancedEcommerceTrackingEventOfEcommerceProductImpression': return funcEnhancedEcommerceTrackingEventOfEcommerceProductImpression(model);
        case 'EnhancedEcommerceTrackingEventOfEcommerceProductRemoveFromCartClick': return funcEnhancedEcommerceTrackingEventOfEcommerceProductRemoveFromCartClick(model);
        case 'EnhancedEcommerceTrackingEventOfEcommercePromotionClick': return funcEnhancedEcommerceTrackingEventOfEcommercePromotionClick(model);
        case 'EnhancedEcommerceTrackingEventOfEcommercePromotionImpression': return funcEnhancedEcommerceTrackingEventOfEcommercePromotionImpression(model);
        case 'EnhancedEcommerceTrackingEventOfEcommercePurchase': return funcEnhancedEcommerceTrackingEventOfEcommercePurchase(model);
        case 'EnhancedEcommerceTrackingEventOfCmsObjectTracking': return funcEnhancedEcommerceTrackingEventOfCmsObjectTracking(model);
        case 'EnhancedEcommerceTrackingEventOfGaStandardProductAddToCartClick': return funcEnhancedEcommerceTrackingEventOfGaStandardProductAddToCartClick(model);
        default:
            return defaultFunc();
    }
}

export function DeliveryMethodDiscriminator<T>(
    model: components["schemas"]["UpsaleDeliveryMethod"] | components["schemas"]["DeliveryMethod"] | components["schemas"]["SelectedDeliveryMethod"],
    funcUpsaleDeliveryMethod: (m: components['schemas']['UpsaleDeliveryMethod']) => T,
    funcDeliveryMethod: (m: components['schemas']['DeliveryMethod']) => T,
    funcSelectedDeliveryMethod: (m: components['schemas']['SelectedDeliveryMethod']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'UpsaleDeliveryMethod': return funcUpsaleDeliveryMethod(model);
        case 'DeliveryMethod': return funcDeliveryMethod(model);
        case 'SelectedDeliveryMethod': return funcSelectedDeliveryMethod(model);
        default:
            return defaultFunc();
    }
}

export function DeliveryMethodCategoryDiscriminator<T>(
    model: components["schemas"]["DeliveryMethodCategory"] | components["schemas"]["SelectedDeliveryMethod"],
    funcDeliveryMethodCategory: (m: components['schemas']['DeliveryMethodCategory']) => T,
    funcSelectedDeliveryMethod: (m: components['schemas']['SelectedDeliveryMethod']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'DeliveryMethodCategory': return funcDeliveryMethodCategory(model);
        case 'SelectedDeliveryMethod': return funcSelectedDeliveryMethod(model);
        default:
            return defaultFunc();
    }
}

export function DeliveryMessageDiscriminator<T>(
    model: components["schemas"]["DropShipNoStorePickup"] | components["schemas"]["FixedDeliveryMessage"] | components["schemas"]["FreeDeliveryWithClubMatasMessage"] | components["schemas"]["SubscriptionsMessage"],
    funcDropShipNoStorePickup: (m: components['schemas']['DropShipNoStorePickup']) => T,
    funcFixedDeliveryMessage: (m: components['schemas']['FixedDeliveryMessage']) => T,
    funcFreeDeliveryWithClubMatasMessage: (m: components['schemas']['FreeDeliveryWithClubMatasMessage']) => T,
    funcSubscriptionsMessage: (m: components['schemas']['SubscriptionsMessage']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'DropShipNoStorePickup': return funcDropShipNoStorePickup(model);
        case 'FixedDeliveryMessage': return funcFixedDeliveryMessage(model);
        case 'FreeDeliveryWithClubMatasMessage': return funcFreeDeliveryWithClubMatasMessage(model);
        case 'SubscriptionsMessage': return funcSubscriptionsMessage(model);
        default:
            return defaultFunc();
    }
}

export function DeliveryPriceDiscriminator<T>(
    model: components["schemas"]["DeliveryPrice"] | components["schemas"]["ParcelShopPrice"] | components["schemas"]["SubscriptionDeliveryPrice"],
    funcDeliveryPrice: (m: components['schemas']['DeliveryPrice']) => T,
    funcParcelShopPrice: (m: components['schemas']['ParcelShopPrice']) => T,
    funcSubscriptionDeliveryPrice: (m: components['schemas']['SubscriptionDeliveryPrice']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'DeliveryPrice': return funcDeliveryPrice(model);
        case 'ParcelShopPrice': return funcParcelShopPrice(model);
        case 'SubscriptionDeliveryPrice': return funcSubscriptionDeliveryPrice(model);
        default:
            return defaultFunc();
    }
}

export function EcommerceDiscriminator<T>(
    model: components["schemas"]["EcommerceBasketSize"] | components["schemas"]["EcommerceCheckoutStep"] | components["schemas"]["EcommerceProductAddToCartClick"] | components["schemas"]["EcommerceProductClick"] | components["schemas"]["EcommerceProductDetail"] | components["schemas"]["EcommerceProductImpression"] | components["schemas"]["EcommerceProductRemoveFromCartClick"] | components["schemas"]["EcommercePromotionClick"] | components["schemas"]["EcommercePromotionImpression"] | components["schemas"]["EcommercePurchase"] | components["schemas"]["CmsObjectTracking"] | components["schemas"]["GaStandardProductAddToCartClick"],
    funcEcommerceBasketSize: (m: components['schemas']['EcommerceBasketSize']) => T,
    funcEcommerceCheckoutStep: (m: components['schemas']['EcommerceCheckoutStep']) => T,
    funcEcommerceProductAddToCartClick: (m: components['schemas']['EcommerceProductAddToCartClick']) => T,
    funcEcommerceProductClick: (m: components['schemas']['EcommerceProductClick']) => T,
    funcEcommerceProductDetail: (m: components['schemas']['EcommerceProductDetail']) => T,
    funcEcommerceProductImpression: (m: components['schemas']['EcommerceProductImpression']) => T,
    funcEcommerceProductRemoveFromCartClick: (m: components['schemas']['EcommerceProductRemoveFromCartClick']) => T,
    funcEcommercePromotionClick: (m: components['schemas']['EcommercePromotionClick']) => T,
    funcEcommercePromotionImpression: (m: components['schemas']['EcommercePromotionImpression']) => T,
    funcEcommercePurchase: (m: components['schemas']['EcommercePurchase']) => T,
    funcCmsObjectTracking: (m: components['schemas']['CmsObjectTracking']) => T,
    funcGaStandardProductAddToCartClick: (m: components['schemas']['GaStandardProductAddToCartClick']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'EcommerceBasketSize': return funcEcommerceBasketSize(model);
        case 'EcommerceCheckoutStep': return funcEcommerceCheckoutStep(model);
        case 'EcommerceProductAddToCartClick': return funcEcommerceProductAddToCartClick(model);
        case 'EcommerceProductClick': return funcEcommerceProductClick(model);
        case 'EcommerceProductDetail': return funcEcommerceProductDetail(model);
        case 'EcommerceProductImpression': return funcEcommerceProductImpression(model);
        case 'EcommerceProductRemoveFromCartClick': return funcEcommerceProductRemoveFromCartClick(model);
        case 'EcommercePromotionClick': return funcEcommercePromotionClick(model);
        case 'EcommercePromotionImpression': return funcEcommercePromotionImpression(model);
        case 'EcommercePurchase': return funcEcommercePurchase(model);
        case 'CmsObjectTracking': return funcCmsObjectTracking(model);
        case 'GaStandardProductAddToCartClick': return funcGaStandardProductAddToCartClick(model);
        default:
            return defaultFunc();
    }
}

export function ListItemDiscriminator<T>(
    model: components["schemas"]["ListItem"] | components["schemas"]["ListRowItem"] | components["schemas"]["ProductListItemModel"],
    funcListItem: (m: components['schemas']['ListItem']) => T,
    funcListRowItem: (m: components['schemas']['ListRowItem']) => T,
    funcProductListItemModel: (m: components['schemas']['ProductListItemModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ListItem': return funcListItem(model);
        case 'ListRowItem': return funcListRowItem(model);
        case 'ProductListItemModel': return funcProductListItemModel(model);
        default:
            return defaultFunc();
    }
}

export function FrontPageSectionContentDiscriminator<T>(
    model: components["schemas"]["MatasPlusCalculatorBannerModel"] | components["schemas"]["MatasPlusSavingsBannerModel"] | components["schemas"]["BannerModel"] | components["schemas"]["BonusChecksModel"] | components["schemas"]["BrandClubListModel"] | components["schemas"]["FavoritesModel"] | components["schemas"]["HeaderModel"] | components["schemas"]["ImageModel"] | components["schemas"]["KicksHeaderModel"] | components["schemas"]["OrdersModel"] | components["schemas"]["PersonalOffersModel"] | components["schemas"]["ProductListModel"] | components["schemas"]["RecommendationsModel"] | components["schemas"]["ReviewRequestsModel"] | components["schemas"]["SubscriptionsModel"] | components["schemas"]["UnboxingOffersModel"] | components["schemas"]["MatasPlusNudgeMessage"],
    funcMatasPlusCalculatorBannerModel: (m: components['schemas']['MatasPlusCalculatorBannerModel']) => T,
    funcMatasPlusSavingsBannerModel: (m: components['schemas']['MatasPlusSavingsBannerModel']) => T,
    funcBannerModel: (m: components['schemas']['BannerModel']) => T,
    funcBonusChecksModel: (m: components['schemas']['BonusChecksModel']) => T,
    funcBrandClubListModel: (m: components['schemas']['BrandClubListModel']) => T,
    funcFavoritesModel: (m: components['schemas']['FavoritesModel']) => T,
    funcHeaderModel: (m: components['schemas']['HeaderModel']) => T,
    funcImageModel: (m: components['schemas']['ImageModel']) => T,
    funcKicksHeaderModel: (m: components['schemas']['KicksHeaderModel']) => T,
    funcOrdersModel: (m: components['schemas']['OrdersModel']) => T,
    funcPersonalOffersModel: (m: components['schemas']['PersonalOffersModel']) => T,
    funcProductListModel: (m: components['schemas']['ProductListModel']) => T,
    funcRecommendationsModel: (m: components['schemas']['RecommendationsModel']) => T,
    funcReviewRequestsModel: (m: components['schemas']['ReviewRequestsModel']) => T,
    funcSubscriptionsModel: (m: components['schemas']['SubscriptionsModel']) => T,
    funcUnboxingOffersModel: (m: components['schemas']['UnboxingOffersModel']) => T,
    funcMatasPlusNudgeMessage: (m: components['schemas']['MatasPlusNudgeMessage']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'MatasPlusCalculatorBannerModel': return funcMatasPlusCalculatorBannerModel(model);
        case 'MatasPlusSavingsBannerModel': return funcMatasPlusSavingsBannerModel(model);
        case 'BannerModel': return funcBannerModel(model);
        case 'BonusChecksModel': return funcBonusChecksModel(model);
        case 'BrandClubListModel': return funcBrandClubListModel(model);
        case 'FavoritesModel': return funcFavoritesModel(model);
        case 'HeaderModel': return funcHeaderModel(model);
        case 'ImageModel': return funcImageModel(model);
        case 'KicksHeaderModel': return funcKicksHeaderModel(model);
        case 'OrdersModel': return funcOrdersModel(model);
        case 'PersonalOffersModel': return funcPersonalOffersModel(model);
        case 'ProductListModel': return funcProductListModel(model);
        case 'RecommendationsModel': return funcRecommendationsModel(model);
        case 'ReviewRequestsModel': return funcReviewRequestsModel(model);
        case 'SubscriptionsModel': return funcSubscriptionsModel(model);
        case 'UnboxingOffersModel': return funcUnboxingOffersModel(model);
        case 'MatasPlusNudgeMessage': return funcMatasPlusNudgeMessage(model);
        default:
            return defaultFunc();
    }
}

export function CustomListItemDiscriminator<T>(
    model: components["schemas"]["ConnectedContentFullwidthModel"] | components["schemas"]["ConnectedContentInlineModel"] | components["schemas"]["ConnectedContentInventoryLaneBlockModel"] | components["schemas"]["ConnectedContentMenuItemModel"] | components["schemas"]["ConnectedContentProductDisplayModel"],
    funcConnectedContentFullwidthModel: (m: components['schemas']['ConnectedContentFullwidthModel']) => T,
    funcConnectedContentInlineModel: (m: components['schemas']['ConnectedContentInlineModel']) => T,
    funcConnectedContentInventoryLaneBlockModel: (m: components['schemas']['ConnectedContentInventoryLaneBlockModel']) => T,
    funcConnectedContentMenuItemModel: (m: components['schemas']['ConnectedContentMenuItemModel']) => T,
    funcConnectedContentProductDisplayModel: (m: components['schemas']['ConnectedContentProductDisplayModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ConnectedContentFullwidthModel': return funcConnectedContentFullwidthModel(model);
        case 'ConnectedContentInlineModel': return funcConnectedContentInlineModel(model);
        case 'ConnectedContentInventoryLaneBlockModel': return funcConnectedContentInventoryLaneBlockModel(model);
        case 'ConnectedContentMenuItemModel': return funcConnectedContentMenuItemModel(model);
        case 'ConnectedContentProductDisplayModel': return funcConnectedContentProductDisplayModel(model);
        default:
            return defaultFunc();
    }
}

export function LiveEventListBlockViewModelDiscriminator<T>(
    model: components["schemas"]["LiveEventBlockViewModel"] | components["schemas"]["SubscribeToNotificationsBlockViewModel"],
    funcLiveEventBlockViewModel: (m: components['schemas']['LiveEventBlockViewModel']) => T,
    funcSubscribeToNotificationsBlockViewModel: (m: components['schemas']['SubscribeToNotificationsBlockViewModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'LiveEventBlockViewModel': return funcLiveEventBlockViewModel(model);
        case 'SubscribeToNotificationsBlockViewModel': return funcSubscribeToNotificationsBlockViewModel(model);
        default:
            return defaultFunc();
    }
}

export function MenuItemContentViewModelDiscriminator<T>(
    model: components["schemas"]["MenuItemCustomActionViewModel"] | components["schemas"]["MenuItemCustomActionWithUrlViewModel"] | components["schemas"]["MenuItemLinkViewModel"] | components["schemas"]["MenuItemLoginOrMyProfileViewModel"] | components["schemas"]["MenuItemMyProfileViewModel"] | components["schemas"]["MenuItemSubMenuViewModel"],
    funcMenuItemCustomActionViewModel: (m: components['schemas']['MenuItemCustomActionViewModel']) => T,
    funcMenuItemCustomActionWithUrlViewModel: (m: components['schemas']['MenuItemCustomActionWithUrlViewModel']) => T,
    funcMenuItemLinkViewModel: (m: components['schemas']['MenuItemLinkViewModel']) => T,
    funcMenuItemLoginOrMyProfileViewModel: (m: components['schemas']['MenuItemLoginOrMyProfileViewModel']) => T,
    funcMenuItemMyProfileViewModel: (m: components['schemas']['MenuItemMyProfileViewModel']) => T,
    funcMenuItemSubMenuViewModel: (m: components['schemas']['MenuItemSubMenuViewModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'MenuItemCustomActionViewModel': return funcMenuItemCustomActionViewModel(model);
        case 'MenuItemCustomActionWithUrlViewModel': return funcMenuItemCustomActionWithUrlViewModel(model);
        case 'MenuItemLinkViewModel': return funcMenuItemLinkViewModel(model);
        case 'MenuItemLoginOrMyProfileViewModel': return funcMenuItemLoginOrMyProfileViewModel(model);
        case 'MenuItemMyProfileViewModel': return funcMenuItemMyProfileViewModel(model);
        case 'MenuItemSubMenuViewModel': return funcMenuItemSubMenuViewModel(model);
        default:
            return defaultFunc();
    }
}

export function MenuItemViewModelDiscriminator<T>(
    model: components["schemas"]["MenuItemViewModel"] | components["schemas"]["ConnectedContentMenuItemModel"],
    funcMenuItemViewModel: (m: components['schemas']['MenuItemViewModel']) => T,
    funcConnectedContentMenuItemModel: (m: components['schemas']['ConnectedContentMenuItemModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'MenuItemViewModel': return funcMenuItemViewModel(model);
        case 'ConnectedContentMenuItemModel': return funcConnectedContentMenuItemModel(model);
        default:
            return defaultFunc();
    }
}

export function AbstractOrderDetailedModelDiscriminator<T>(
    model: components["schemas"]["OfflineOrderDetailedModel"] | components["schemas"]["OrderDetailedModel"] | components["schemas"]["UpsaleOrderDetailedModel"],
    funcOfflineOrderDetailedModel: (m: components['schemas']['OfflineOrderDetailedModel']) => T,
    funcOrderDetailedModel: (m: components['schemas']['OrderDetailedModel']) => T,
    funcUpsaleOrderDetailedModel: (m: components['schemas']['UpsaleOrderDetailedModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'OfflineOrderDetailedModel': return funcOfflineOrderDetailedModel(model);
        case 'OrderDetailedModel': return funcOrderDetailedModel(model);
        case 'UpsaleOrderDetailedModel': return funcUpsaleOrderDetailedModel(model);
        default:
            return defaultFunc();
    }
}

export function PointInfoModelDiscriminator<T>(
    model: components["schemas"]["StandardPointInfoModel"] | components["schemas"]["MatasPlusPointInfoModel"],
    funcStandardPointInfoModel: (m: components['schemas']['StandardPointInfoModel']) => T,
    funcMatasPlusPointInfoModel: (m: components['schemas']['MatasPlusPointInfoModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'StandardPointInfoModel': return funcStandardPointInfoModel(model);
        case 'MatasPlusPointInfoModel': return funcMatasPlusPointInfoModel(model);
        default:
            return defaultFunc();
    }
}

export function MediaContentDiscriminator<T>(
    model: components["schemas"]["ImageContent"] | components["schemas"]["VideoContent"],
    funcImageContent: (m: components['schemas']['ImageContent']) => T,
    funcVideoContent: (m: components['schemas']['VideoContent']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ImageContent': return funcImageContent(model);
        case 'VideoContent': return funcVideoContent(model);
        default:
            return defaultFunc();
    }
}

export function StockStatusViewModelDiscriminator<T>(
    model: components["schemas"]["StockStatusViewModel"] | components["schemas"]["StockStatusWithPreciseDeliveryAndModalViewModel"] | components["schemas"]["StockStatusWithPreciseDeliveryViewModel"],
    funcStockStatusViewModel: (m: components['schemas']['StockStatusViewModel']) => T,
    funcStockStatusWithPreciseDeliveryAndModalViewModel: (m: components['schemas']['StockStatusWithPreciseDeliveryAndModalViewModel']) => T,
    funcStockStatusWithPreciseDeliveryViewModel: (m: components['schemas']['StockStatusWithPreciseDeliveryViewModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'StockStatusViewModel': return funcStockStatusViewModel(model);
        case 'StockStatusWithPreciseDeliveryAndModalViewModel': return funcStockStatusWithPreciseDeliveryAndModalViewModel(model);
        case 'StockStatusWithPreciseDeliveryViewModel': return funcStockStatusWithPreciseDeliveryViewModel(model);
        default:
            return defaultFunc();
    }
}

export function ProductMediaContentDiscriminator<T>(
    model: components["schemas"]["ProductVideoModel"] | components["schemas"]["Product360Directory"] | components["schemas"]["ProductImage"],
    funcProductVideoModel: (m: components['schemas']['ProductVideoModel']) => T,
    funcProduct360Directory: (m: components['schemas']['Product360Directory']) => T,
    funcProductImage: (m: components['schemas']['ProductImage']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ProductVideoModel': return funcProductVideoModel(model);
        case 'Product360Directory': return funcProduct360Directory(model);
        case 'ProductImage': return funcProductImage(model);
        default:
            return defaultFunc();
    }
}

export function MenuItemElementViewModelDiscriminator<T>(
    model: components["schemas"]["TextElementViewModel"] | components["schemas"]["LinkElementViewModel"],
    funcTextElementViewModel: (m: components['schemas']['TextElementViewModel']) => T,
    funcLinkElementViewModel: (m: components['schemas']['LinkElementViewModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'TextElementViewModel': return funcTextElementViewModel(model);
        case 'LinkElementViewModel': return funcLinkElementViewModel(model);
        default:
            return defaultFunc();
    }
}

export function FilterViewModelDiscriminator<T>(
    model: components["schemas"]["PriceFilterViewModel"] | components["schemas"]["BrandFilterViewModel"] | components["schemas"]["BoolFilterViewModel"] | components["schemas"]["BoolStarFilterViewModel"] | components["schemas"]["RangeFilterViewModel"] | components["schemas"]["ColorFilterViewModel"] | components["schemas"]["LinkFilterViewModel"],
    funcPriceFilterViewModel: (m: components['schemas']['PriceFilterViewModel']) => T,
    funcBrandFilterViewModel: (m: components['schemas']['BrandFilterViewModel']) => T,
    funcBoolFilterViewModel: (m: components['schemas']['BoolFilterViewModel']) => T,
    funcBoolStarFilterViewModel: (m: components['schemas']['BoolStarFilterViewModel']) => T,
    funcRangeFilterViewModel: (m: components['schemas']['RangeFilterViewModel']) => T,
    funcColorFilterViewModel: (m: components['schemas']['ColorFilterViewModel']) => T,
    funcLinkFilterViewModel: (m: components['schemas']['LinkFilterViewModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'PriceFilterViewModel': return funcPriceFilterViewModel(model);
        case 'BrandFilterViewModel': return funcBrandFilterViewModel(model);
        case 'BoolFilterViewModel': return funcBoolFilterViewModel(model);
        case 'BoolStarFilterViewModel': return funcBoolStarFilterViewModel(model);
        case 'RangeFilterViewModel': return funcRangeFilterViewModel(model);
        case 'ColorFilterViewModel': return funcColorFilterViewModel(model);
        case 'LinkFilterViewModel': return funcLinkFilterViewModel(model);
        default:
            return defaultFunc();
    }
}

export function ActiveFilterViewModelDiscriminator<T>(
    model: components["schemas"]["SimpleActiveFilter"] | components["schemas"]["ColorActiveFilter"],
    funcSimpleActiveFilter: (m: components['schemas']['SimpleActiveFilter']) => T,
    funcColorActiveFilter: (m: components['schemas']['ColorActiveFilter']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'SimpleActiveFilter': return funcSimpleActiveFilter(model);
        case 'ColorActiveFilter': return funcColorActiveFilter(model);
        default:
            return defaultFunc();
    }
}

export function ProductListHeaderDiscriminator<T>(
    model: components["schemas"]["ProductListBonusGiftHeaderModel"] | components["schemas"]["ProductListBrandHeaderModel"] | components["schemas"]["ProductListOfferHeaderModel"] | components["schemas"]["ProductListRebuyHeaderModel"] | components["schemas"]["ProductListTextHeaderModel"],
    funcProductListBonusGiftHeaderModel: (m: components['schemas']['ProductListBonusGiftHeaderModel']) => T,
    funcProductListBrandHeaderModel: (m: components['schemas']['ProductListBrandHeaderModel']) => T,
    funcProductListOfferHeaderModel: (m: components['schemas']['ProductListOfferHeaderModel']) => T,
    funcProductListRebuyHeaderModel: (m: components['schemas']['ProductListRebuyHeaderModel']) => T,
    funcProductListTextHeaderModel: (m: components['schemas']['ProductListTextHeaderModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ProductListBonusGiftHeaderModel': return funcProductListBonusGiftHeaderModel(model);
        case 'ProductListBrandHeaderModel': return funcProductListBrandHeaderModel(model);
        case 'ProductListOfferHeaderModel': return funcProductListOfferHeaderModel(model);
        case 'ProductListRebuyHeaderModel': return funcProductListRebuyHeaderModel(model);
        case 'ProductListTextHeaderModel': return funcProductListTextHeaderModel(model);
        default:
            return defaultFunc();
    }
}

export function ProductTabContentDiscriminator<T>(
    model: components["schemas"]["ProductTabBlockListModel"] | components["schemas"]["ProductTabContentBrandTeaserModel"] | components["schemas"]["ProductTabDeliveryAndReturnModel"] | components["schemas"]["ProductTabDescriptionModel"] | components["schemas"]["ProductTabHighlightsModel"] | components["schemas"]["ProductTabIconListModel"] | components["schemas"]["ProductTabPropertyListModel"] | components["schemas"]["ProductTabTableListModel"] | components["schemas"]["ProductTabTableModel"] | components["schemas"]["ProductTabUsageModel"],
    funcProductTabBlockListModel: (m: components['schemas']['ProductTabBlockListModel']) => T,
    funcProductTabContentBrandTeaserModel: (m: components['schemas']['ProductTabContentBrandTeaserModel']) => T,
    funcProductTabDeliveryAndReturnModel: (m: components['schemas']['ProductTabDeliveryAndReturnModel']) => T,
    funcProductTabDescriptionModel: (m: components['schemas']['ProductTabDescriptionModel']) => T,
    funcProductTabHighlightsModel: (m: components['schemas']['ProductTabHighlightsModel']) => T,
    funcProductTabIconListModel: (m: components['schemas']['ProductTabIconListModel']) => T,
    funcProductTabPropertyListModel: (m: components['schemas']['ProductTabPropertyListModel']) => T,
    funcProductTabTableListModel: (m: components['schemas']['ProductTabTableListModel']) => T,
    funcProductTabTableModel: (m: components['schemas']['ProductTabTableModel']) => T,
    funcProductTabUsageModel: (m: components['schemas']['ProductTabUsageModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ProductTabBlockListModel': return funcProductTabBlockListModel(model);
        case 'ProductTabContentBrandTeaserModel': return funcProductTabContentBrandTeaserModel(model);
        case 'ProductTabDeliveryAndReturnModel': return funcProductTabDeliveryAndReturnModel(model);
        case 'ProductTabDescriptionModel': return funcProductTabDescriptionModel(model);
        case 'ProductTabHighlightsModel': return funcProductTabHighlightsModel(model);
        case 'ProductTabIconListModel': return funcProductTabIconListModel(model);
        case 'ProductTabPropertyListModel': return funcProductTabPropertyListModel(model);
        case 'ProductTabTableListModel': return funcProductTabTableListModel(model);
        case 'ProductTabTableModel': return funcProductTabTableModel(model);
        case 'ProductTabUsageModel': return funcProductTabUsageModel(model);
        default:
            return defaultFunc();
    }
}

export function RecommendationRequestDiscriminator<T>(
    model: components["schemas"]["ProductRecommendationRequest"] | components["schemas"]["BasketRecommendationRequest"] | components["schemas"]["ProductGroupRecommendationRequest"] | components["schemas"]["SearchResultRecommendationRequest"] | components["schemas"]["ZeroSearchResultRecommendationRequest"] | components["schemas"]["HomePageRecommendationRequest"] | components["schemas"]["PowerstepRecommendationRequest"] | components["schemas"]["PowerstepTwoRecommendationRequest"] | components["schemas"]["ReceiptPageRecommendationRequest"] | components["schemas"]["CustomRecommendationRequest"] | components["schemas"]["RecommendationByPlacementRequest"],
    funcProductRecommendationRequest: (m: components['schemas']['ProductRecommendationRequest']) => T,
    funcBasketRecommendationRequest: (m: components['schemas']['BasketRecommendationRequest']) => T,
    funcProductGroupRecommendationRequest: (m: components['schemas']['ProductGroupRecommendationRequest']) => T,
    funcSearchResultRecommendationRequest: (m: components['schemas']['SearchResultRecommendationRequest']) => T,
    funcZeroSearchResultRecommendationRequest: (m: components['schemas']['ZeroSearchResultRecommendationRequest']) => T,
    funcHomePageRecommendationRequest: (m: components['schemas']['HomePageRecommendationRequest']) => T,
    funcPowerstepRecommendationRequest: (m: components['schemas']['PowerstepRecommendationRequest']) => T,
    funcPowerstepTwoRecommendationRequest: (m: components['schemas']['PowerstepTwoRecommendationRequest']) => T,
    funcReceiptPageRecommendationRequest: (m: components['schemas']['ReceiptPageRecommendationRequest']) => T,
    funcCustomRecommendationRequest: (m: components['schemas']['CustomRecommendationRequest']) => T,
    funcRecommendationByPlacementRequest: (m: components['schemas']['RecommendationByPlacementRequest']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'ProductRecommendationRequest': return funcProductRecommendationRequest(model);
        case 'BasketRecommendationRequest': return funcBasketRecommendationRequest(model);
        case 'ProductGroupRecommendationRequest': return funcProductGroupRecommendationRequest(model);
        case 'SearchResultRecommendationRequest': return funcSearchResultRecommendationRequest(model);
        case 'ZeroSearchResultRecommendationRequest': return funcZeroSearchResultRecommendationRequest(model);
        case 'HomePageRecommendationRequest': return funcHomePageRecommendationRequest(model);
        case 'PowerstepRecommendationRequest': return funcPowerstepRecommendationRequest(model);
        case 'PowerstepTwoRecommendationRequest': return funcPowerstepTwoRecommendationRequest(model);
        case 'ReceiptPageRecommendationRequest': return funcReceiptPageRecommendationRequest(model);
        case 'CustomRecommendationRequest': return funcCustomRecommendationRequest(model);
        case 'RecommendationByPlacementRequest': return funcRecommendationByPlacementRequest(model);
        default:
            return defaultFunc();
    }
}

export function DestinationDiscriminator<T>(
    model: components["schemas"]["CompanyAddress"] | components["schemas"]["ParcelShop"] | components["schemas"]["PrivateAddress"],
    funcCompanyAddress: (m: components['schemas']['CompanyAddress']) => T,
    funcParcelShop: (m: components['schemas']['ParcelShop']) => T,
    funcPrivateAddress: (m: components['schemas']['PrivateAddress']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'CompanyAddress': return funcCompanyAddress(model);
        case 'ParcelShop': return funcParcelShop(model);
        case 'PrivateAddress': return funcPrivateAddress(model);
        default:
            return defaultFunc();
    }
}

export function VisualSearchResultUseCaseModelDiscriminator<T>(
    model: components["schemas"]["BestMatchUseCaseModel"] | components["schemas"]["EmptyResultUseCaseModel"] | components["schemas"]["ResultListUseCaseModel"] | components["schemas"]["VisualSearchErrorUseCaseModel"],
    funcBestMatchUseCaseModel: (m: components['schemas']['BestMatchUseCaseModel']) => T,
    funcEmptyResultUseCaseModel: (m: components['schemas']['EmptyResultUseCaseModel']) => T,
    funcResultListUseCaseModel: (m: components['schemas']['ResultListUseCaseModel']) => T,
    funcVisualSearchErrorUseCaseModel: (m: components['schemas']['VisualSearchErrorUseCaseModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'BestMatchUseCaseModel': return funcBestMatchUseCaseModel(model);
        case 'EmptyResultUseCaseModel': return funcEmptyResultUseCaseModel(model);
        case 'ResultListUseCaseModel': return funcResultListUseCaseModel(model);
        case 'VisualSearchErrorUseCaseModel': return funcVisualSearchErrorUseCaseModel(model);
        default:
            return defaultFunc();
    }
}

export function IBasketPrizeCertificateInfoBoxDiscriminator<T>(
    model: components["schemas"]["BasketPrizeCertificateModel"] | components["schemas"]["BasketPrizeCertificateNotAvailableModel"],
    funcBasketPrizeCertificateModel: (m: components['schemas']['BasketPrizeCertificateModel']) => T,
    funcBasketPrizeCertificateNotAvailableModel: (m: components['schemas']['BasketPrizeCertificateNotAvailableModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'BasketPrizeCertificateModel': return funcBasketPrizeCertificateModel(model);
        case 'BasketPrizeCertificateNotAvailableModel': return funcBasketPrizeCertificateNotAvailableModel(model);
        default:
            return defaultFunc();
    }
}

export function OrderSimpleModelDiscriminator<T>(
    model: components["schemas"]["OfflineOrderSimpleModel"] | components["schemas"]["OrderSimpleModel"] | components["schemas"]["UpsaleOrderSimpleModel"],
    funcOfflineOrderSimpleModel: (m: components['schemas']['OfflineOrderSimpleModel']) => T,
    funcOrderSimpleModel: (m: components['schemas']['OrderSimpleModel']) => T,
    funcUpsaleOrderSimpleModel: (m: components['schemas']['UpsaleOrderSimpleModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'OfflineOrderSimpleModel': return funcOfflineOrderSimpleModel(model);
        case 'OrderSimpleModel': return funcOrderSimpleModel(model);
        case 'UpsaleOrderSimpleModel': return funcUpsaleOrderSimpleModel(model);
        default:
            return defaultFunc();
    }
}

export function IPowerstepViewModelDiscriminator<T>(
    model: components["schemas"]["BrandClubPowerstepViewModel"] | components["schemas"]["PowerstepViewModel"],
    funcBrandClubPowerstepViewModel: (m: components['schemas']['BrandClubPowerstepViewModel']) => T,
    funcPowerstepViewModel: (m: components['schemas']['PowerstepViewModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'BrandClubPowerstepViewModel': return funcBrandClubPowerstepViewModel(model);
        case 'PowerstepViewModel': return funcPowerstepViewModel(model);
        default:
            return defaultFunc();
    }
}

export function GroupedBasketResultModelDiscriminator<T>(
    model: components["schemas"]["GroupedBasketResultModel"] | components["schemas"]["RedirectGroupedBasketResultModel"],
    funcGroupedBasketResultModel: (m: components['schemas']['GroupedBasketResultModel']) => T,
    funcRedirectGroupedBasketResultModel: (m: components['schemas']['RedirectGroupedBasketResultModel']) => T,
    defaultFunc: () => T
): T {
    switch (model?.$type) {
        case 'GroupedBasketResultModel': return funcGroupedBasketResultModel(model);
        case 'RedirectGroupedBasketResultModel': return funcRedirectGroupedBasketResultModel(model);
        default:
            return defaultFunc();
    }
};
